import { STRING, LOOKUP, METADATA } from "@/domain/data.types";

export default {
  data() {
    return {
      parseDataType: {
        [STRING]: this.parseString,
        [METADATA]: this.parseString,
        [LOOKUP]: this.parseLookup
      }
    };
  },
  methods: {
    getDataTypeName(type) {
      let item = this.attributeTypes.find(item => item.type === type);
      return item ? item.name : false;
    },
    parseString(attributeType) {
      if (attributeType.length) {
        return `${this.getDataTypeName(attributeType.type)} (${
          attributeType.length
        })`;
      } else {
        return `${this.getDataTypeName(attributeType.type)}`;
      }
    },
    getReferenceName(id) {
      let item = this.references.find(r => r.id === id);
      return item ? item.name : this.$t("system_unknown");
    },
    parseLookup(attributeType) {
      return `${this.getDataTypeName(
        attributeType.type
      )} (${this.getReferenceName(attributeType.lookUpId)})`;
    },
    getAttributeName(attributeType) {
      if (this.getDataTypeName(attributeType.type)) {
        return this.parseDataType[attributeType.type]
          ? this.parseDataType[attributeType.type](attributeType)
          : this.getDataTypeName(attributeType.type);
      }
      return this.$t("system_unknown");
    }
  }
};
